import { FirebaseDataService } from "../../services/firebase-data.service";

const firebaseDataService = new FirebaseDataService();

export function fetchUserSavedHeatmapData(statsObj, user, graph) {
  console.log('Fetching user saved heatmap data with statsObj:', statsObj);
    return firebaseDataService.getDataFromDB(statsObj, user, graph)
      .then(data => ({ data }))
      .catch(error => { throw error; });
  }
  
  export function updateUserSavedHeatmapData(statsObj, payload) {
    return firebaseDataService.updateDataInDB(statsObj, payload)
      .then(data => ({ data }))
      .catch(error => { throw error; });
  }
  
  export function deleteUserSavedHeatmapData(statsObj) {
    return firebaseDataService.deleteDataInDB(statsObj)
      .then(response => ({ response }))
      .catch(error => { throw error; });
  }

 